import React from 'react';
import Layout from '../layouts/layout';
import SEO from '../layouts/seo';
import { isMobile } from '../utils/browser.js';
import PCSCENE from '../scenes/newYearVideo/pc/index';
import MOBILESCENE from '../scenes/newYearVideo/mobile/index';

class NewYearVideo extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			renderStyle: '',
			orientation: 0
		};
	}

	componentDidMount() {
		this.setState({
			renderStyle: isMobile() ? 'mobile' : 'pc',
			orientation: window.orientation
		});
		window.onorientationchange = () => {
			this.setState({
				orientation: window.orientation
			});
		};
	}

	render() {
		return (
			<Layout>
				<SEO title="百胜棋牌给您拜年" description="百胜棋牌给您拜年" />
				{this.renderScene()}
			</Layout>
		);
	}

	renderScene() {
		const { renderStyle, orientation } = this.state;
		if (orientation === 90 || orientation === -90) {
			return <PCSCENE />;
		} else {
			if (renderStyle === 'mobile') {
				return <MOBILESCENE />;
			} else if (renderStyle === 'pc') {
				return <PCSCENE />;
			} else {
				return null;
			}
		}
	}
}

export default NewYearVideo;
